import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { TextField } from '@mui/material';
import { ROUTES } from 'config/constants';
import styles from '../TradeInFormModal.module.scss';
import PhoneKeyboard from 'assets/images/phone-keyboard.png';

const Page3 = ({ tradeInDeviceIMEI, setTradeInDeviceIMEI, deviceInfo, roughEstimate, isTncChecked, setIsTncChecked }) => {
    return (
        <div className={styles.page3}>
            {roughEstimate && deviceInfo?.selectedDevice
                ? <>
                    <div className={styles.roughEstimate}>
                        <div className={styles.deviceInfo}>
                            <div className={styles.container}>
                                <p className={styles.device}>
                                    {deviceInfo?.selectedCategory}
                                </p>
                                <p className={styles.device}>
                                    {deviceInfo?.selectedDevice}
                                </p>
                            </div>
                            <div className={styles.container}>
                                <p className={styles.device}>Estimated trade-in value</p>
                                <p className={styles.value}>S${roughEstimate}</p>
                            </div>
                        </div>
                        <p className={styles.note}>
                        *Actual trade-in value may differ from estimated trade-in value
                        </p>
                    </div>
                    <hr />
                </>
                : null}

            <div className={styles.content}>
                <p className={styles.title}>
                    Help us to further validate your trade-in device
                </p>
                <div className={styles.form}>
                    <div>
                        <p className={styles.label}>
                            Enter IMEI number of your device (or if you have a Wi-Fi only
                            device, enter the serial number)
                            <span className={styles.note}>*</span>
                        </p>
                        <TextField id='imei' label='IMEI' variant='standard'
                            value={tradeInDeviceIMEI} onChange={(e) => setTradeInDeviceIMEI(e.target.value)}
                            className={styles.imeiInput}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '&.Mui-focused fieldset': {
                                        borderColor: 'transparent',
                                        boxShadow: 'none'
                                    }
                                },
                                '& .MuiInputLabel-root.Mui-focused': {
                                    color: 'inherit'
                                }
                            }}/>
                    </div>
                    <div className={styles.info}>
                        <img src={PhoneKeyboard} alt='phone keyboard'
                            className={styles.phoneKeyboard} />
                        <div>
                            <p className={styles.font700}>
                                How do I find my IMEI number?
                            </p>
                            <p className={`${styles.font300} ${styles.mb4}`}>
                                Open your device&apos;s call screen and enter *#06# or look
                                for the number in a general &quot;About&quot; section in
                                settings
                            </p>
                            <p className={styles.font700}>
                                How do I find my serial number?
                            </p>
                            <p className={styles.font300}>
                                Go to your device &quot;About&quot; settings or device
                                packaging to locate the serial number. Please enter the
                                serial number without any spaces or special characters (e.g.
                                / , -, #, :, @, ~, ^)
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div className={styles.footer}>
                <p className={styles.note1}>
                    Confirm Terms and Conditions
                </p>
                <div className={styles.mt4}>
                    <div className={styles.tncContainer}>
                        <span className={styles.textRed}>*</span>
                        <input
                            type='checkbox'
                            id='tnc'
                            name='tnc'
                            value='tnc'
                            checked={isTncChecked}
                            onChange={(e) => setIsTncChecked(e.target.checked)}
                            className={styles.checkbox} />
                        <label
                            htmlFor='tnc'
                            className={styles.label}>
                            I have read and agree to the Trade-in Terms and Conditions{' '}
                        </label>
                    </div>
                    <p className={styles.textRed}>* Required field</p>
                </div>
                <p className={styles.note2}>
                    Please note charges may apply if you fail to send us your device
                    within the stipulated time period. Please refer to the{' '}
                    <Link
                        className={styles.link}
                        to={ROUTES.TERMS_AND_CONDITIONS}
                        target='_blank'>
                        Terms & Conditions
                    </Link>{' '}
                    for more information. We will use your personal data in accordance
                    with our{' '}
                    <Link
                        className={styles.link}
                        to={ROUTES.PRIVACY_POLICY}
                        target='_blank'>
                        Privacy Policy
                    </Link>
                    .
                </p>
            </div>
        </div>
    );
};

export default Page3;

Page3.propTypes = {
    tradeInDeviceIMEI: PropTypes.string.isRequired,
    setTradeInDeviceIMEI: PropTypes.func.isRequired,
    deviceInfo: PropTypes.object.isRequired,
    roughEstimate: PropTypes.number.isRequired,
    isTncChecked: PropTypes.bool.isRequired,
    setIsTncChecked: PropTypes.func.isRequired
};
